export const UPDATE_NODE = 'update_node';
export const ADD_NODE_DOMAIN = 'add_node_domain';
export const DELETE_NODE_DOMAIN = 'delete_node_domain';
export const DELETE_NODE = 'delete_node';
export const DISCARD_NODE = 'discard_node';
export const UPDATE_NODES_CONFIGURATION = 'update_nodes_configurations';
export const LDAP_IP_ADDED = 'node_ldap_ip_added';
